const Resources = {

    table_headers: [
        {
            text:   'Walking#',
            value:  'walking_number',
            type:   'link',
        },
        { 
            text:   'Description',
            value:  'description',
            type:   'link',
            with_icon: true,
            src_icon: '/assets/img/svg/customdescriptionicon.svg',
        },
        { 
            text:   'Minutes',
            value:  'daily_minutes'
        },
        { 
            text:   'Sq.Feet',
            value:  'sq_ft'
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks'
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

   summary_table_headers: [
        {
            name: "#",
        },
        {
            name: "Associate",
        },
        {
            name: "Error",
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates - Mass Edit Associates',
            href:   '/associates-mass-edit',
            arrow:  "",
        },
    ],

    helps: [
        {
            label: '¿How to Mass Edit Associates?', 
            instruction: `https://scribehow.com/embed/How_To_Mass_Edit_Associates_In_Digital_Solutions__nOdzK82xTQGAs1XLq-oD0w?as=scrollable`
        },
    ]

}

export default Resources